import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    // Simulate authentication check from localStorage
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setAuthenticated(true);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Prevent redirect before checking auth
  }

  return authenticated || user ? children : <Navigate to="/admin-login" />;
};

export default ProtectedRoute;
